import { connect } from 'react-redux'
import { setSignUpModalIsOpen } from 'redux/actions'
import ListItem from 'pages/legislationcategories/ListItem'

const mapStateToProps = state => ({
  isLogged: state.user.isLogged
})

const mapDispatchToProps = dispatch => ({
  setSignUpModalIsOpen: isOpen => dispatch(setSignUpModalIsOpen(isOpen))
})

export default connect(mapStateToProps, mapDispatchToProps)(ListItem)
